import React from 'react';
import PropTypes from 'prop-types';
import values from 'lodash/values';
import RightHandLinkButton from '@Components/Results/right-hand-link-button.component';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import NumberFormatter from '@Utils/NumberFormatter';
import SubstanceHelper from '@Components/Results/services/substance-helper.factory';
import uuid from 'uuid/v4';

export default class SubstanceRightHandLinks extends React.PureComponent {
  static checkLinkCounts(links) {
    return values(links).reduce((result, count) => result || count > 0, false);
  }

  constructor(props) {
    super(props);

    this.openElementLink = this.openElementLink.bind(this);
  }

  openElementLink(type) {
    const { metadata } = this.props;
    const requestParams = {
      hitSetKey: metadata.hitSetKey,
      resultName: metadata.resultName,
      searchId: metadata.searchId || uuid(), // results or preview
    };

    if (metadata.order) {
      requestParams.order = metadata.order;
    }

    // eslint-disable-next-line react/destructuring-assignment
    SubstanceHelper.openElementLink(type, this.props.substance, requestParams);
  }

  renderLink(count, type) {
    const capitalize = (string) => string[0].toUpperCase() + string.slice(1);

    return count > 0 ? (
      <RightHandLinkButton
        openElementLink={this.openElementLink}
        dataLinkType={type}
        text={`${capitalize(type)} - ${NumberFormatter(count)}`}
        type="link"
        iconPosition="right"
        size="sm"
        icon="chevron-right"
      />
    ) : null;
  }

  render() {
    const {
      substance: { links },
    } = this.props;

    return links && this.constructor.checkLinkCounts(links) ? (
      <>
        {this.renderLink(links.preparationsCount, 'preparations')}
        {this.renderLink(links.reactionsCount, 'reactions')}
        {this.renderLink(links.targetsCount, 'targets')}
        {this.renderLink(links.documentCount, 'documents')}
      </>
    ) : null;
  }
}

SubstanceRightHandLinks.propTypes = {
  metadata: MetadataPropTypesShape,
  substance: PropTypes.shape({
    links: PropTypes.shape({
      preparationsCount: PropTypes.number,
      reactionsCount: PropTypes.number,
      targetsCount: PropTypes.number,
      documentCount: PropTypes.number,
    }),
  }).isRequired,
};
